import React from 'react';
import { isEmpty } from 'ramda';
import NoContentPlaceholder from '../../../components/NoContentPlaceholder/NoContentPlaceholder';
import GameCardsGridVirtualized from '../../components/GameCardsGrid/GameCardsGridVirtualized';
import { useInfinityQueryGames } from '../../../hooks/API/useQueryGames';
import { DEFAULT_QUERY_LIMIT } from '../../../hooks/API/constants';
import ReviewTwoColumnLayout from '../../layouts/TwoColumnLayout/TwoColumnLayout';
import ScrollRestoration from '../../../components/ScrollRestoration/ScrollRestoration';
import SearchBar from '../../../components/SearchBar/SearchBar';
import { useSearchParam } from '../../../hooks/useSearchParam';
import { useNativeCasinoProvider } from '../../hooks/useNativeCasinoProvider';
import { SEARCH_QUERY_PARAM } from '../../../constants/search';
import styles from './AppReviewSearch.module.css';

export function filterGamesByQuery(list, query) {
  return list?.filter?.((game) =>
    game?.translationKey
      ?.toLowerCase?.()
      ?.includes?.(query?.toLocaleLowerCase?.())
  );
}

export const Search = () => {
  const query = useSearchParam(SEARCH_QUERY_PARAM);
  const provider = useNativeCasinoProvider();

  const { isLoading, isSuccess, data, fetchNextPage } = useInfinityQueryGames(
    {
      search: query,
      provider,
    },
    {
      enabled: true,
    }
  );

  return (
    <ScrollRestoration>
      <ReviewTwoColumnLayout>
        <div className={styles.header}>
          <SearchBar />
        </div>

        {isSuccess && isEmpty(data.pages) ? (
          <NoContentPlaceholder />
        ) : (
          <GameCardsGridVirtualized
            items={filterGamesByQuery(data.pages, query)}
            isLoading={isLoading}
            limit={DEFAULT_QUERY_LIMIT}
            loadMoreGames={fetchNextPage}
          />
        )}
      </ReviewTwoColumnLayout>
    </ScrollRestoration>
  );
};

export default Search;
